import React from 'react';
import ReactDOM from 'react-dom/client';
import App2 from './App2';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App2 />
  </React.StrictMode>
);
serviceWorkerRegistration.register();